import { LicenseFeature } from "./license-feature.model";
import { LicenseIntegration } from "./license-integration";

export class License {
	key: string;

	name: string;

	type: string;

	secret: string;

	venueKey: number;

	dealerKey: string;

	integratorKey: string;

	bundleKey: string;

	mac: string;

	ip: string;
	serialNumber: string;

	printerId: number;

	stationId: number;
	posStationId: number;

	claimed: boolean;

	active?: boolean;

	created: Date;

	updated: Date;

	lastUsed: Date;

	softwareVersion: string;
	posVersion: string;

	deviceType: string;

	price: number;

	paymentType: string;

	paymentName: string;

	sourceName: string;

	// ~ Option to suppress emails & sms messages from being sent on checks created by this license.
	suppressEmailSms: boolean;

	// licenseActivations: LicenseActivation[];

	licenseIntegrations: LicenseIntegration[];

	venueName?: string;

	dealerName?: string;

	integratorName?: string;

	sessionVenueKey: number;

	integrations?: LicenseIntegration[];

	features: LicenseFeature;

	lastHeartbeat: string;

	public constructor(init?: Partial<License>) {
		Object.assign(this, init);
	}
}
